module.exports = __webpack_public_path__ + "img/document-medicine.f7b2713c.svg";